import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { encryptParams } from "./encryptUrl"; // aapka existing function

const API_BASE = process.env.REACT_APP_API_URL || "http://187.127.165.240:5000";

export default function WebinarCertificate() {
  const [email, setEmail]       = useState("");
  const [students, setStudents] = useState([]);
  const [current, setCurrent]   = useState(0);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading]   = useState(false);
  const navigate = useNavigate();

  // ── Search student by email ──
  const searchStudent = async () => {
    if (!email.trim()) return alert("Email daalo pehle");
    try {
      setLoading(true);
      const res = await axios.post(`${API_BASE}/webinarStudentGet`, { email });
      setStudents(res.data.data || []);
      setCurrent(0);
      setSearched(true);
    } catch (err) {
      console.error(err);
      alert("Server error — Admin se contact karo");
    } finally {
      setLoading(false);
    }
  };

  // ── Swipe left/right ──
  const prev = () => setCurrent((c) => Math.max(0, c - 1));
  const next = () => setCurrent((c) => Math.min(students.length - 1, c + 1));

  // ── Go to certificate page with encrypted params ──
  const goToCertificate = () => {
    const s = students[current];
    // aapke CSV ke column names match karo yahan
    const token = encryptParams({
      name:           s.Name           || s.name           || "",
      course:         s.Course_Name    || s.course         || "",
      months:         s.Months         || s.months         || "Three",
      completionDate: s.Date           || s.completionDate || "",
      email:          s.email          || s.Email          || "",
      verifyId:       s.verifyId       || s.VerifyId       || "",
    });
 navigate(`/webinar-certificate?d=${token}`);
  };

  // ── Styles ──
  const styles = {
    page: {
      minHeight: "100vh",
      background: "#f3f4f6",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "Montserrat, sans-serif",
      padding: "24px 16px",
      gap: 24,
    },
    searchBox: {
      background: "#fff",
      borderRadius: 16,
      padding: "32px 28px",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
      width: "100%",
      maxWidth: 480,
    },
    title: {
      fontSize: 22,
      fontWeight: 800,
      color: "#1e2736",
      margin: "0 0 8px",
    },
    sub: {
      fontSize: 14,
      color: "#64748b",
      margin: "0 0 20px",
    },
    inputRow: {
      display: "flex",
      gap: 10,
    },
    input: {
      flex: 1,
      padding: "12px 16px",
      borderRadius: 10,
      border: "1.5px solid #e2e8f0",
      fontSize: 14,
      fontFamily: "Montserrat, sans-serif",
      outline: "none",
    },
    btn: (bg = "#f05a28") => ({
      background: bg,
      color: "#fff",
      border: "none",
      padding: "12px 22px",
      borderRadius: 10,
      fontWeight: 700,
      fontSize: 14,
      cursor: "pointer",
      fontFamily: "Montserrat, sans-serif",
      whiteSpace: "nowrap",
    }),
    cardWrap: {
      width: "100%",
      maxWidth: 480,
      position: "relative",
    },
    card: {
      background: "#fff",
      borderRadius: 20,
      padding: "28px 28px 24px",
      boxShadow: "0 8px 30px rgba(0,0,0,0.10)",
      border: "2px solid #f05a28",
      minHeight: 230,
    },
    label: {
      fontSize: 12,
      color: "#94a3b8",
      fontWeight: 600,
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      margin: "0 0 2px",
    },
    value: {
      fontSize: 16,
      color: "#1e2736",
      fontWeight: 700,
      margin: "0 0 14px",
    },
    counter: {
      textAlign: "center",
      fontSize: 13,
      color: "#64748b",
      fontWeight: 600,
      margin: "10px 0 0",
    },
    navRow: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: 14,
      gap: 10,
    },
    navBtn: (disabled) => ({
      background: disabled ? "#e2e8f0" : "#2d3542",
      color: disabled ? "#94a3b8" : "#fff",
      border: "none",
      padding: "10px 20px",
      borderRadius: 10,
      fontWeight: 700,
      fontSize: 14,
      cursor: disabled ? "not-allowed" : "pointer",
      fontFamily: "Montserrat, sans-serif",
    }),
    badge: {
      display: "inline-block",
      background: "#fef3c7",
      color: "#92400e",
      borderRadius: 8,
      padding: "3px 10px",
      fontSize: 12,
      fontWeight: 700,
      marginBottom: 16,
    },
  };

  return (
   <div style={styles.page}>

  {/* Search Box */}
  <div style={styles.searchBox}>
    <h2 style={styles.title}>Certificate Download</h2>
    <p style={styles.sub}>
      Enter your registered email to view all your webinar certificates.
    </p>
    <div style={styles.inputRow}>
      <input
        type="email"
        placeholder="your@email.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && searchStudent()}
        style={styles.input}
      />
      <button
        style={styles.btn()}
        onClick={searchStudent}
        disabled={loading}
      >
        {loading ? "Searching..." : "Search"}
      </button>
    </div>
  </div>

  {/* Results */}
  {searched && students.length === 0 && (
    <div style={{ ...styles.searchBox, textAlign: "center", color: "#64748b" }}>
      <div style={{ fontSize: 40, marginBottom: 10 }}>🔍</div>
      <p style={{ fontWeight: 700, color: "#1e2736", margin: "0 0 6px" }}>
        No records found
      </p>
      <p style={{ fontSize: 14, margin: 0 }}>
        No webinar registrations were found for this email address.
      </p>
    </div>
  )}

  {students.length > 0 && (
    <div style={styles.cardWrap}>

      {/* Card */}
      <div style={styles.card}>
        <span style={styles.badge}>
          Webinar {current + 1} of {students.length}
        </span>

        <p style={styles.label}>Student Name</p>
        <p style={styles.value}>
          {students[current].Name || students[current].name || "—"}
        </p>

        <p style={styles.label}>Email</p>
        <p style={styles.value}>
          {students[current].email || students[current].Email || "—"}
        </p>

        <p style={styles.label}>Course / Webinar</p>
        <p style={styles.value}>
          {students[current].Course_Name || students[current].course || "—"}
        </p>

        <p style={styles.label}>Completion Date</p>
        <p style={styles.value}>
          {students[current].Date || students[current].completionDate || "—"}
        </p>
      </div>

      {/* Navigation Row */}
      <div style={styles.navRow}>
        <button
          style={styles.navBtn(current === 0)}
          onClick={prev}
          disabled={current === 0}
        >
          ← Previous
        </button>

        <button
          style={styles.btn("#16a34a")}
          onClick={goToCertificate}
        >
          Get Certificate ↗
        </button>

        <button
          style={styles.navBtn(current === students.length - 1)}
          onClick={next}
          disabled={current === students.length - 1}
        >
          Next →
        </button>
      </div>

      <p style={styles.counter}>
        Swipe or use the arrow buttons to navigate
      </p>
    </div>
  )}
</div>
  );
}